import { useEffect } from "react";
import HeaderStyleTwo from "../Shared/HeaderStyleTwo";
import Footer from "../Shared/Footer";
import VolunteersBanner from "../Shared/VolunteersBanner";
import Facts from "../Shared/Facts";
const Thanks = () => {
    useEffect(() => {
        runJQueryScripts();
        window.scrollTo(0, 0)
    }, []);

    const runJQueryScripts = () => {
        let tag: any;
        let loadScript = function (src: string) {
            tag = document.createElement("script");
            tag.async = false;
            tag.src = src;
            document.getElementsByTagName("body")[0].appendChild(tag);
        };
        loadScript("../assets/js/jquery.js");
        loadScript("../assets/js/popper.min.js");
        loadScript("../assets/js/jquery-ui.js");
        loadScript("../assets/js/jquery.fancybox.js");
        loadScript("../assets/js/owl.js");
        loadScript("../assets/js/appear.js");
        loadScript("../assets/js/wow.js");
        loadScript("../assets/js/lazyload.js");
        loadScript("../assets/js/scrollbar.js");
        loadScript("../assets/js/script.js");
        return () => {
            document.getElementsByTagName("body")[0].removeChild(tag);
        }
    }
    return (
        <>
            <HeaderStyleTwo />
            {/* <section className="page-banner">
                <div className="image-layer lazy-image" data-bg="url('assets/images/background/bg-banner-1.jpg')"></div>
                <div className="bottom-rotten-curve alternate"></div>
                <div className="auto-container">
                    <h1>About Us</h1>
                    <ul className="bread-crumb clearfix">
                        <li><a href="/">Home</a></li>
                        <li className="active">About Us</li>
                    </ul>
                </div>
            </section> */}
            <div className="ulockd-inner-page">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="ulockd-icd-layer">
                                <ul className="list-inline ulockd-icd-sub-menu">
                                    <li><a style={{ color: '#25283a' }} href="/"> Home </a></li>
                                    <li><a style={{ color: '#25283a' }} href="#"><b> / </b></a></li>
                                    <li> <a href="/founder-message"> Thanks</a> </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="about-section style-two alternate">
                <div className="auto-container">
                    <div className="row clearfix">
                        <div className="left-column col-lg-12 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="sec-title">
                                    <h3>Thank you so much for your generous donation, detailed  receipt has been emailed to you . you will receive email shortly</h3>
                                    <div className="link-box clearfix"><a href="/get-involved" className="theme-btn btn-style-one"><span className="btn-title">Make Another Donation</span></a></div>

                                    {/* <div className="text">
                                        <p>
                                            Sadqa-E-Jariya Welfare Foundation has been established with the goal to support the orphans (yateems) and widows (bewas) of our community. Our beloved Prophet (saw) said those who support the orphan (yateem) will be with me like the 2 fingers together. Our focus is to provide financial support to these individuals and help them become established in society by promoting education and training, to learn skills that can make them self sufficient and transform them from the receivers to the givers, so that they may support the less fortunate. InshaAllah!
                                        </p>
                                        <strong>Our core Islamic principle illustrated in the Gracious Quran:</strong>
                                        <p>
                                            "They feed with food--despite their own desire for it-- the indigent, and the orphan and the captive (saying): ‘We feed you purely for the sake of God. We desire no reward from you, nor thankfulness." <br /> - Surah al-Insan 8-9
                                        </p>
                                        <p>
                                            Please make Dua that Allah give Barakah to this effort as that also becomes a source of sadaqa for you and your family. May Allah accept our efforts in sadqajariya campaign and guides us in the path to success in the hereafter... Ameen!
                                        </p>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    
                    </div>

                  

                </div>

            </section>
           
            <Footer />
        </>
    );
};
export default Thanks;
